//#region Libraries
import { useState, useEffect } from "react";
//#endregion
//#region Styles
import { ButtonLink } from "components/styles";
//#endregion
//#region Components
import DialogChangeHistory from "./components/DialogChangeHistory/DialogChangeHistory";
//#endregion
//#region Services
import { requestGetChangeHistoryResource } from "services/resources/library/aboutLibraryResources";
//#endregion
//#region Utils
import useShowDialogAlert from "components/DialogAlert/utils/hooks/useDialogAlert";
//#endregion

const ChangeHistory = ({
    resource,
    loadingRequest
}) => {
    //#region States
    const dialogShow = useShowDialogAlert();
    const [changeHistory, setChangeHistory] = useState([]);
    //#endregion
    //#region Custom Hooks
    //#endregion
    //#region Effects
    useEffect(() => {
        fillChangeHistory();
    }, []);
    //#endregion
    //#region Functions
    //#endregion
    const fillChangeHistory = async () => {
        loadingRequest.show("Cargando historial...");
        const data = await requestGetChangeHistoryResource(resource.id);
        setChangeHistory(data);
        loadingRequest.hide();
    }
    return (
        <>
        <ButtonLink 
            className={changeHistory.length === 0 ? "disabled" : ""} 
            margin="0 10px"
            onClick={() => dialogShow.toggle()}>Ver historial de cambios</ButtonLink>
        <DialogChangeHistory 
            dialogShow={dialogShow}
            changeHistory={changeHistory}
            resource={resource}/>
        </>
    );
}

export default ChangeHistory;